type Appredirect01ButtonclickedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type Appredirect01PageviewInfo = {

/**
      undefined
      */
url: string
};

type SettingsLoadedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type GtmLoadedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VValueGeneratedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
value: string
};

type CookiesAcceptedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CookiesRejectedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CookiesCustomizingInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CookiesCustomizedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type HomepageSliderInteractionInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type BulkUploadLimitErrorInfo = {

/**
      undefined
      */
errorType: string;

/**
      undefined
      */
fileNumber: number;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type BulkUploadFormatErrorInfo = {

/**
      undefined
      */
errorType: string;

/**
      undefined
      */
fileFormat: number;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoPromotionShownInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CookieLoginCtaShownInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CookieLoginCtaEligibilityEvaluatedInfo = {

/**
      
      */
eligible: boolean;

/**
      
      */
suppressionReason: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CookieLoginCtaLoginTappedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CookieLoginCtaDismissedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoPromotionTappedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
source: 'badge' | 'popup'
};

type VideoPromotionDismissedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type LanguagePickerTappedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
fpc: string
};

type LanguageSelectedInfo = {

/**
      undefined
      */
language: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string
};

type LoginTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
actionValue: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type LoginShownInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
previousAction: string;

/**
      undefined
      */
url: string
};

type LoginDismissedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
previousAction: string;

/**
      undefined
      */
url: string
};

type LoginStartedInfo = {

/**
      undefined
      */
actionValue: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
from: string
};

type LoginCompletedInfo = {

/**
      undefined
      */
actionValue: 'google.com' | 'facebook.com' | 'apple.com';

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
previousAction: string;

/**
      undefined
      */
url: string
};

type UploadStartedInfo = {

/**
      undefined
      */
actionValue: 'drag' | 'browse';

/**
      
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string;

/**
      
      */
mediaQuantity: number
};

type TryPhotoFreeEnhanceTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type AiSettingsSavingIconTappedInfo = {

/**
      
      */
is_logged_in: boolean;

/**
      
      */
will_open: boolean
};

type AiSettingsSaveButtonTappedInfo = {

/**
      
      */
ai_model: string;

/**
      


      */
ai_model_parameters: Record<string, unknown>
};

type AiSettingsSavedInfo = {

/**
      
      */
ai_model: string;

/**
      


      */
ai_model_parameters: Record<string, unknown>
};

type DownloadCtaPopupDisplayedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type DownloadCtaPopupUpgradePlanTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type DownloadCtaPopupDismissedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoEnhanceSubscribePopupDisplayedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoUploadCtaPopupSingleTaskTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoUploadCtaPopupUpgradePlanTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoUploadCtaPopupTrySubscribeTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoUploadCtaPopupLoginTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoUploadCtaPopupDismissedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type AiModelsVariantsClickCtaPopupShownInfo = {

/**
      
      */
chosen_style: string
};

type BatchProcessingCtaPopupShownInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type BatchProcessingCtaPopupDismissedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type BatchProcessingCtaPopupUpgradePlanTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type BatchProcessingCtaPopupSingleTaskTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type BatchProcessingCtaPopupTrySubscribeTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type BatchProcessingCtaPopupLoginTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type VideoEnhanceLimitErrorInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
errorType: string
};

type UploadCompletedInfo = {

/**
      undefined
      */
actionValue: 'drag' | 'browse';

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string
};

type UploadTooManyFilesInfo = {

/**
      undefined
      */
actionValue: 'drag' | 'browse';

/**
      
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type OnboardingSurveyDisplayedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type OnboardingSurveyDismissedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type OnboardingSurveyCompletedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
onboarding_survey_responses: string
};

type SurveySubmittedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
webUserId: string
};

type ReprocessingStartedInfo = {

/**
      undefined
      */
actionValue: 'drag' | 'browse';

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string
};

type ReprocessingCompletedInfo = {

/**
      undefined
      */
actionValue: 'drag' | 'browse';

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string;

/**
      undefined
      */
mediaQuantity: number;

/**
      undefined
      */
aiModels: string;

/**
      


      */
aiModelParameters: Record<string, unknown>;

/**
      


      */
aiModelParametersList: string
};

type ProcessingStartedInfo = {

/**
      undefined
      */
actionValue: 'drag' | 'browse';

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string
};

type ProcessingCompletedInfo = {

/**
      undefined
      */
actionValue: 'drag' | 'browse';

/**
      
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string;

/**
      undefined
      */
bulkUploadId: string;

/**
      undefined
      */
mediaQuantity: string;

/**
      undefined
      */
aiModels: string;

/**
      


      */
aiModelParameters: Record<string, unknown>;

/**
      


      */
aiModelParametersList: string
};

type ProcessingCancelledInfo = {

/**
      undefined
      */
actionValue: 'cancel';

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      

      */
mediaType: string
};

type ServerDownloadStartedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type ServerDownloadCompletedInfo = {

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string
};

type ProcessedImageShownInfo = {

/**
      undefined
      */
email: string;

/**
      undefined
      */
hasWatermark: boolean;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
aiModel: string;

/**
      


      */
aiModelParameters: Record<string, unknown>
};

type ProcessedImageUnavailableInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string
};

type TutorialSkippedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      
      */
tutorialId: string
};

type TutorialCompletedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      
      */
tutorialId: string
};

type OutputFormatConversionSubscribePopupDisplayedInfo = {

/**
      
      */
requestedFormat: string
};

type EditorSliderInteractionInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type EditorZoomedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type EditorFittedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type EditorPannedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type EditorImageModelSelectedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      
      */
aiModel: string;

/**
      
      */
aiToolbarSelection: string
};

type DownloadTappedInfo = {

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
nextAction: 'user_download' | 'paywall' | 'login';

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
mediaType: string;

/**
      
      */
taskId: string;

/**
      
      */
extension: string;

/**
      undefined
      */
aiModel: string;

/**
      


      */
aiModelParameters: Record<string, unknown>
};

type BatchDownloadTappedInfo = {

/**
      
      */
bulkUploadId: string;

/**
      
      */
mediaQuantity: string
};

type DownloadSidebarOpenedInfo = {

/**
      
      */
media_type: string;

/**
      
      */
task_id: string
};

type UserDownloadTriggeredInfo = {

/**
      
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
mimeType: 'image/png' | 'image/jpeg' | 'image/tiff';

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
aiModel: string;

/**
      


      */
aiModelParameters: Record<string, unknown>;

/**
      undefined
      */
mediaType: string
};

type UploadNewTappedInfo = {

/**
      
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type OutputConversionStartedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
mimeType: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type OutputConversionCompletedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
mimeType: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type UpgradeModalConfirmedInfo = {

/**
      
      */
subscriptionProvider: 'stripe' | 'paypal';

/**
      
      */
refundAmount: number;

/**
      
      */
daysLeft: number;

/**
      
      */
wasTrialing: boolean
};

type UpgradeModalUpgradeFailedInfo = {

/**
      
      */
subscriptionProvider: 'stripe' | 'paypal';

/**
      
      */
wasTrialing: boolean
};

type UpgradeModalUpgradeSuccessInfo = {

/**
      
      */
subscriptionProvider: 'stripe' | 'paypal';

/**
      
      */
refundAmount: number;

/**
      
      */
wasTrialing: boolean
};

type PaywallTierConfirmedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string;

/**
      
      */
email: string;

/**
      
      */
selectedTier: string;

/**
      
      */
isUpgrade: boolean
};

type PaywallTierSelectedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
url: string;

/**
      
      */
email: string;

/**
      
      */
paywallDesign: string;

/**
      
      */
selectedTier: string
};

type PaywallEmailReminderDisabledInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string
};

type PaywallEmailReminderEnabledInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
email: string
};

type SubscribeTappedInfo = {

/**
      undefined
      */
actionValue: 'Subscribe (CTA)';

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type PcpWeeklyTappedInfo = {

/**
      undefined
      */
freeTrial: boolean
};

type PcpYearlyTappedInfo = {

/**
      undefined
      */
freeTrial: boolean
};

type PcpContinueTappedInfo = {

/**
      undefined
      */
periodicity: 7 | 360;

/**
      undefined
      */
freeTrial: boolean
};

type PcpOthersTappedInfo = {

/**
      undefined
      */
freeTrial: boolean
};

type PcpDismissedInfo = {

/**
      undefined
      */
freeTrial: boolean
};

type OcpContinueTappedInfo = {

/**
      undefined
      */
planChosen: 'welcome' | 'free'
};

type PaywallPriceSelectedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
priceIds: string;

/**
      undefined
      */
priceId: string;

/**
      undefined
      */
selectedPeriod: string;

/**
      
      */
isUpgrade: boolean
};

type PaywallShownInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
previousAction: string;

/**
      undefined
      */
priceIds: string;

/**
      undefined
      */
type: 'old' | 'pcp' | 'ocp';

/**
      undefined
      */
url: string
};

type PaymentSelectedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
paymentPlatform: 'card' | 'paypal' | 'google' | 'apple';

/**
      undefined
      */
paymentStrategy: 'subscription' | 'oneTime';

/**
      undefined
      */
previousAction: string;

/**
      
      */
offerPlan: 'weekly' | 'yearly' | 'welcome' | 'free';

/**
      undefined
      */
freeTrialEnabled: boolean;

/**
      undefined
      */
priceId: string;

/**
      undefined
      */
url: string
};

type PaymentCompletedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
paymentPlatform: 'card' | 'paypal' | 'google' | 'apple';

/**
      undefined
      */
paymentStrategy: 'subscription' | 'oneTime';

/**
      undefined
      */
priceId: string;

/**
      undefined
      */
freeTrialEnabled: boolean;

/**
      undefined
      */
emailReminderEnabled: boolean;

/**
      undefined
      */
previousAction: string;

/**
      
      */
offerPlan: 'weekly' | 'yearly' | 'welcome' | 'free';

/**
      undefined
      */
url: string
};

type PaywallDismissedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
previousAction: string;

/**
      undefined
      */
priceIds: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
email: string
};

type FreeTrialEnabledInfo = {

/**
      undefined
      */
previousAction: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
priceIds: string
};

type FreeTrialDisabledInfo = {

/**
      undefined
      */
previousAction: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
priceIds: string
};

type FreeTrialTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
actionValue: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
email: string
};

type StripeCardLimitReachedInfo = {

/**
      undefined
      */
email: string
};

type AccountTappedInfo = {

/**
      undefined
      */
actionValue: 'My Account (CTA)';

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type SettingsGeneralTappedInfo = {

/**
      undefined
      */
actionValue: 'General (CTA)';

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type SettingsSubscriptionTappedInfo = {

/**
      undefined
      */
actionValue: 'Subscription (CTA)';

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type SettingsCancelPlanTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type SettingsWithdrawalTappedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type SettingsUpgradePlanTappedInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type SettingsLogoutTappedInfo = {

/**
      undefined
      */
actionValue: 'Logout (CTA)';

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type CancellationConfirmedModalShownInfo = {

/**
      
      */
is_email_cancellation: boolean;

/**
      
      */
cancellation_code: string
};

type CancellationFailedModalShownInfo = {

/**
      
      */
is_email_cancellation: boolean;

/**
      
      */
cancellation_code: string
};

type CancellationFailedModalTryAgainTappedInfo = {

/**
      
      */
is_email_cancellation: boolean;

/**
      
      */
cancellation_code: string
};

type CancellationFailedModalContactSupportTappedInfo = {

/**
      
      */
is_email_cancellation: boolean;

/**
      
      */
cancellation_code: string
};

type CancellationModalShownInfo = {

/**
      
      */
is_email_cancellation: boolean;

/**
      
      */
cancellation_code: string
};

type CancellationModalAcceptedInfo = {

/**
      
      */
is_email_cancellation: boolean;

/**
      
      */
cancellation_code: string
};

type CancellationModalDismissedInfo = {

/**
      
      */
is_email_cancellation: boolean;

/**
      
      */
cancellation_code: string
};

type WithdrawalModalShownInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string
};

type WithdrawalModalAcceptedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string
};

type WithdrawalModalDismissedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string
};

type WithdrawalModalEmailSubmittedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string
};

type WithdrawalModalCompletedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string;

/**
      
      */
refunded_amount_cents: number
};

type WithdrawalModalFailedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string;

/**
      
      */
error_code: string
};

type WithdrawalModalRetryTappedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string;

/**
      
      */
error_code: string
};

type WithdrawalModalContactSupportTappedInfo = {

/**
      
      */
will_refund: boolean;

/**
      
      */
days_remaining: number;

/**
      
      */
provider: string;

/**
      
      */
error_code: string
};

type MobileSubscriptionRedeemCompletedInfo = {

/**
      undefined
      */
url: string;

/**
      undefined
      */
backendId: string
};

type MobileSubscriptionRedeemFailedInfo = {

/**
      undefined
      */
url: string;

/**
      undefined
      */
backendId: string
};

type MobileSubscriptionRedeemStartedInfo = {

/**
      undefined
      */
url: string;

/**
      undefined
      */
backendId: string
};

type SettingsPrivacySectionTappedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
email: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
url: string
};

type ShareButtonClickInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
email: string
};

type ShareModalCopyInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
email: string;

/**
      undefined
      */
from: string
};

type ShareModalDismissedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
email: string
};

type ShareModalShownInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
email: string
};

type SharedImageUnavailableInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string
};

type SharedImageShownInfo = {

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
hasWatermark: boolean
};

type PopupMarketingConsentShownInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
email: string
};

type PopupMarketingConsentAcceptedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string
};

type MarketingToggleChangedInfo = {

/**
      
      */
choice: boolean;

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbc: string;

/**
      undefined
      */
fbp: string
};

type PopupImageTrainingConsentShownInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string
};

type PopupImageTrainingConsentAcceptedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string;

/**
      undefined
      */
email: string
};

type PopupImageTrainingConsentNotAcceptedInfo = {

/**
      undefined
      */
page: string;

/**
      undefined
      */
url: string;

/**
      undefined
      */
fbp: string
};

type ImageTrainingToggleChangedInfo = {

/**
      
      */
choice: boolean;

/**
      
      */
page: string;

/**
      
      */
url: string;

/**
      
      */
fbp: string;

/**
      
      */
fbc: string
};

type SecretMenuOpenedInfo = {

/**
      
      */
page: string;

/**
      
      */
url: string;

/**
      
      */
fbp: string
};

type SecretMenuAttemptFailedInfo = {

/**
      
      */
page: string;

/**
      
      */
url: string;

/**
      
      */
fbp: string
};

type SecretMenuExperimentsUpdatedInfo = {

/**
      
      */
page: string;

/**
      
      */
url: string;

/**
      
      */
fbp: string
};

type GiftCodeSubmittedInfo = {

/**
      
      */
page: string;

/**
      
      */
url: string
};

type GiftCodeAcceptedInfo = {

/**
      
      */
redeemCode: string;

/**
      
      */
page: string;

/**
      
      */
url: string;

/**
      
      */
fbp: string
};

type GiftCodeErroredInfo = {

/**
      
      */
page: string;

/**
      
      */
fbp: string;

/**
      
      */
redeemCode: string;

/**
      
      */
url: string;

/**
      
      */
errorMessage: string
};

type DownloadAppCtaPageviewInfo = {

/**
      
      */
page: string;

/**
      
      */
url: string
};

type DownloadAppCtaDownloadAppTappedInfo = {

/**
      
      */
page: string;

/**
      
      */
url: string
};

export const getTrackingSchemaAPI = (track: (actionKind:string, actionInfo?:Object) => void) => {
        

  
/**
      
      */
const trackAppredirect01Buttonclicked = (info: Appredirect01ButtonclickedInfo) => track('app-redirect-01_button-clicked', info);


/**
      
      */
const trackAppredirect01Pageview = (info: Appredirect01PageviewInfo) => track('app-redirect-01_pageview', info);


/**
      
      */
const trackSessionStart = () => track('session_start');


/**
      
      */
const trackSettingsLoaded = (info: SettingsLoadedInfo) => track('settings_loaded', info);


/**
      
      */
const trackGtmLoaded = (info: GtmLoadedInfo) => track('gtm_loaded', info);


/**
      
      */
const trackVValueGenerated = (info: VValueGeneratedInfo) => track('v_value_generated', info);


/**
      
      */
const trackCookiesAccepted = (info: CookiesAcceptedInfo) => track('cookies_accepted', info);


/**
      

      */
const trackCookiesRejected = (info: CookiesRejectedInfo) => track('cookies_rejected', info);


/**
      

      */
const trackCookiesCustomizing = (info: CookiesCustomizingInfo) => track('cookies_customizing', info);


/**
      
      */
const trackCookiesCustomized = (info: CookiesCustomizedInfo) => track('cookies_customized', info);


/**
      


      */
const trackHomepageSliderInteraction = (info: HomepageSliderInteractionInfo) => track('homepage_slider_interaction', info);


/**
      
      */
const trackBulkUploadLimitError = (info: BulkUploadLimitErrorInfo) => track('bulk_upload_limit_error', info);


/**
      
      */
const trackBulkUploadFormatError = (info: BulkUploadFormatErrorInfo) => track('bulk_upload_format_error', info);


/**
      
      */
const trackVideoPromotionShown = (info: VideoPromotionShownInfo) => track('video_promotion_shown', info);


/**
      
      */
const trackCookieLoginCtaShown = (info: CookieLoginCtaShownInfo) => track('cookie_login_cta_shown', info);


/**
      
      */
const trackCookieLoginCtaEligibilityEvaluated = (info: CookieLoginCtaEligibilityEvaluatedInfo) => track('cookie_login_cta_eligibility_evaluated', info);


/**
      
      */
const trackCookieLoginCtaLoginTapped = (info: CookieLoginCtaLoginTappedInfo) => track('cookie_login_cta_login_tapped', info);


/**
      
      */
const trackCookieLoginCtaDismissed = (info: CookieLoginCtaDismissedInfo) => track('cookie_login_cta_dismissed', info);


/**
      
      */
const trackVideoPromotionTapped = (info: VideoPromotionTappedInfo) => track('video_promotion_tapped', info);


/**
      

      */
const trackVideoPromotionDismissed = (info: VideoPromotionDismissedInfo) => track('video_promotion_dismissed', info);


/**
      
      */
const trackLanguagePickerTapped = (info: LanguagePickerTappedInfo) => track('language_picker_tapped', info);


/**
      
      */
const trackLanguageSelected = (info: LanguageSelectedInfo) => track('language_selected', info);


/**
      
      */
const trackLoginTapped = (info: LoginTappedInfo) => track('login_tapped', info);


/**
      
      */
const trackLoginShown = (info: LoginShownInfo) => track('login_shown', info);


/**
      
      */
const trackLoginDismissed = (info: LoginDismissedInfo) => track('login_dismissed', info);


/**
      
      */
const trackLoginStarted = (info: LoginStartedInfo) => track('login_started', info);


/**
      
      */
const trackLoginCompleted = (info: LoginCompletedInfo) => track('login_completed', info);


/**
      
      */
const trackUploadStarted = (info: UploadStartedInfo) => track('upload_started', info);


/**
      

      */
const trackTryPhotoFreeEnhanceTapped = (info: TryPhotoFreeEnhanceTappedInfo) => track('try_photo_free_enhance_tapped', info);


/**
      
      */
const trackAiSettingsSavingIconTapped = (info: AiSettingsSavingIconTappedInfo) => track('ai_settings_saving_icon_tapped', info);


/**
      
      */
const trackAiSettingsSaveButtonTapped = (info: AiSettingsSaveButtonTappedInfo) => track('ai_settings_save_button_tapped', info);


/**
      
      */
const trackAiSettingsSaved = (info: AiSettingsSavedInfo) => track('ai_settings_saved', info);


/**
      
      */
const trackAiSettingsSavingModalShown = () => track('ai_settings_saving_modal_shown');


/**
      
      */
const trackAiSettingsSavingModalAccepted = () => track('ai_settings_saving_modal_accepted');


/**
      
      */
const trackAiSettingsSavingModalDismissed = () => track('ai_settings_saving_modal_dismissed');


/**
      
      */
const trackDownloadCtaPopupDisplayed = (info: DownloadCtaPopupDisplayedInfo) => track('download_cta_popup_displayed', info);


/**
      

      */
const trackDownloadCtaPopupUpgradePlanTapped = (info: DownloadCtaPopupUpgradePlanTappedInfo) => track('download_cta_popup_upgrade_plan_tapped', info);


/**
      
      */
const trackDownloadCtaPopupDismissed = (info: DownloadCtaPopupDismissedInfo) => track('download_cta_popup_dismissed', info);


/**
      

      */
const trackVideoEnhanceSubscribePopupDisplayed = (info: VideoEnhanceSubscribePopupDisplayedInfo) => track('video_enhance_subscribe_popup_displayed', info);


/**
      
      */
const trackVideoUploadCtaPopupSingleTaskTapped = (info: VideoUploadCtaPopupSingleTaskTappedInfo) => track('video_upload_cta_popup_single_task_tapped', info);


/**
      
      */
const trackVideoUploadCtaPopupUpgradePlanTapped = (info: VideoUploadCtaPopupUpgradePlanTappedInfo) => track('video_upload_cta_popup_upgrade_plan_tapped', info);


/**
      
      */
const trackVideoUploadCtaPopupTrySubscribeTapped = (info: VideoUploadCtaPopupTrySubscribeTappedInfo) => track('video_upload_cta_popup_try_subscribe_tapped', info);


/**
      
      */
const trackVideoUploadCtaPopupLoginTapped = (info: VideoUploadCtaPopupLoginTappedInfo) => track('video_upload_cta_popup_login_tapped', info);


/**
      
      */
const trackVideoUploadCtaPopupDismissed = (info: VideoUploadCtaPopupDismissedInfo) => track('video_upload_cta_popup_dismissed', info);


/**
      
      */
const trackAiModelsDropdownClickCtaPopupShown = () => track('ai_models_dropdown_click_cta_popup_shown');


/**
      
      */
const trackAiModelsDropdownClickCtaPopupTrySubscribeTapped = () => track('ai_models_dropdown_click_cta_popup_try_subscribe_tapped');


/**
      
      */
const trackAiModelsDropdownClickCtaPopupLoginTapped = () => track('ai_models_dropdown_click_cta_popup_login_tapped');


/**
      
      */
const trackAiModelsDropdownClickCtaPopupDismissed = () => track('ai_models_dropdown_click_cta_popup_dismissed');


/**
      

      */
const trackAiModelsVariantsClickCtaPopupShown = (info: AiModelsVariantsClickCtaPopupShownInfo) => track('ai_models_variants_click_cta_popup_shown', info);


/**
      
      */
const trackAiModelsVariantsClickCtaPopupTrySubscribeTapped = () => track('ai_models_variants_click_cta_popup_try_subscribe_tapped');


/**
      
      */
const trackAiModelsVariantsClickCtaPopupLoginTapped = () => track('ai_models_variants_click_cta_popup_login_tapped');


/**
      
      */
const trackAiModelsVariantsClickCtaPopupUpgradePlanTapped = () => track('ai_models_variants_click_cta_popup_upgrade_plan_tapped');


/**
      
      */
const trackAiModelsVariantsClickCtaPopupDismissed = () => track('ai_models_variants_click_cta_popup_dismissed');


/**
      

      */
const trackBatchProcessingCtaPopupShown = (info: BatchProcessingCtaPopupShownInfo) => track('batch_processing_cta_popup_shown', info);


/**
      
      */
const trackBatchProcessingCtaPopupDismissed = (info: BatchProcessingCtaPopupDismissedInfo) => track('batch_processing_cta_popup_dismissed', info);


/**
      
      */
const trackBatchProcessingCtaPopupUpgradePlanTapped = (info: BatchProcessingCtaPopupUpgradePlanTappedInfo) => track('batch_processing_cta_popup_upgrade_plan_tapped', info);


/**
      
      */
const trackBatchProcessingCtaPopupSingleTaskTapped = (info: BatchProcessingCtaPopupSingleTaskTappedInfo) => track('batch_processing_cta_popup_single_task_tapped', info);


/**
      

      */
const trackBatchProcessingCtaPopupTrySubscribeTapped = (info: BatchProcessingCtaPopupTrySubscribeTappedInfo) => track('batch_processing_cta_popup_try_subscribe_tapped', info);


/**
      
      */
const trackBatchProcessingCtaPopupLoginTapped = (info: BatchProcessingCtaPopupLoginTappedInfo) => track('batch_processing_cta_popup_login_tapped', info);


/**
      

      */
const trackVideoEnhanceLimitError = (info: VideoEnhanceLimitErrorInfo) => track('video_enhance_limit_error', info);


/**
      
      */
const trackUploadCompleted = (info: UploadCompletedInfo) => track('upload_completed', info);


/**
      
      */
const trackUploadTooManyFiles = (info: UploadTooManyFilesInfo) => track('upload_too_many_files', info);


/**
      
      */
const trackOnboardingSurveyDisplayed = (info: OnboardingSurveyDisplayedInfo) => track('onboarding_survey_displayed', info);


/**
      
      */
const trackOnboardingSurveyDismissed = (info: OnboardingSurveyDismissedInfo) => track('onboarding_survey_dismissed', info);


/**
      

      */
const trackOnboardingSurveyCompleted = (info: OnboardingSurveyCompletedInfo) => track('onboarding_survey_completed', info);


/**
      undefined
      */
const trackSurveySubmitted = (info: SurveySubmittedInfo) => track('survey_submitted', info);


/**
      
      */
const trackReprocessingStarted = (info: ReprocessingStartedInfo) => track('reprocessing_started', info);


/**
      
      */
const trackReprocessingCompleted = (info: ReprocessingCompletedInfo) => track('reprocessing_completed', info);


/**
      
      */
const trackProcessingStarted = (info: ProcessingStartedInfo) => track('processing_started', info);


/**
      
      */
const trackProcessingCompleted = (info: ProcessingCompletedInfo) => track('processing_completed', info);


/**
      

      */
const trackProcessingCancelled = (info: ProcessingCancelledInfo) => track('processing_cancelled', info);


/**
      
      */
const trackServerDownloadStarted = (info: ServerDownloadStartedInfo) => track('server_download_started', info);


/**
      
      */
const trackServerDownloadCompleted = (info: ServerDownloadCompletedInfo) => track('server_download_completed', info);


/**
      
      */
const trackProcessedImageShown = (info: ProcessedImageShownInfo) => track('processed_image_shown', info);


/**
      
      */
const trackProcessedImageUnavailable = (info: ProcessedImageUnavailableInfo) => track('processed_image_unavailable', info);


/**
      
      */
const trackTutorialSkipped = (info: TutorialSkippedInfo) => track('tutorial_skipped', info);


/**
      
      */
const trackTutorialCompleted = (info: TutorialCompletedInfo) => track('tutorial_completed', info);


/**
      

      */
const trackOutputFormatConversionCtaPopupUpgradePlanTapped = () => track('output_format_conversion_cta_popup_upgrade_plan_tapped');


/**
      
      */
const trackOutputFormatConversionCtaPopupTrySubscribeTapped = () => track('output_format_conversion_cta_popup_try_subscribe_tapped');


/**
      

      */
const trackOutputFormatConversionCtaPopupLoginTapped = () => track('output_format_conversion_cta_popup_login_tapped');


/**
      

      */
const trackOutputFormatConversionCtaPopupDismissed = () => track('output_format_conversion_cta_popup_dismissed');


/**
      
      */
const trackOutputFormatConversionSubscribePopupDisplayed = (info: OutputFormatConversionSubscribePopupDisplayedInfo) => track('output_format_conversion_subscribe_popup_displayed', info);


/**
      
      */
const trackEditorSliderInteraction = (info: EditorSliderInteractionInfo) => track('editor_slider_interaction', info);


/**
      
      */
const trackEditorZoomed = (info: EditorZoomedInfo) => track('editor_zoomed', info);


/**
      
      */
const trackEditorFitted = (info: EditorFittedInfo) => track('editor_fitted', info);


/**
      
      */
const trackEditorPanned = (info: EditorPannedInfo) => track('editor_panned', info);


/**
      

      */
const trackEditorImageModelSelected = (info: EditorImageModelSelectedInfo) => track('editor_image_model_selected', info);


/**
      
      */
const trackDownloadTapped = (info: DownloadTappedInfo) => track('download_tapped', info);


/**
      
      */
const trackBatchDownloadTapped = (info: BatchDownloadTappedInfo) => track('batch_download_tapped', info);


/**
      
      */
const trackDownloadSidebarOpened = (info: DownloadSidebarOpenedInfo) => track('download_sidebar_opened', info);


/**
      
      */
const trackUserDownloadTriggered = (info: UserDownloadTriggeredInfo) => track('user_download_triggered', info);


/**
      

      */
const trackAiModelMismatchModalShown = () => track('ai_model_mismatch_modal_shown');


/**
      

      */
const trackAiModelMismatchModalAccepted = () => track('ai_model_mismatch_modal_accepted');


/**
      

      */
const trackAiModelMismatchModalNotAccepted = () => track('ai_model_mismatch_modal_not_accepted');


/**
      

      */
const trackOverwriteAllFormatsModalShown = () => track('overwrite_all_formats_modal_shown');


/**
      

      */
const trackOverwriteAllFormatsModalAccepted = () => track('overwrite_all_formats_modal_accepted');


/**
      
      */
const trackOverwriteAllFormatsModalNotAccepted = () => track('overwrite_all_formats_modal_not_accepted');


/**
      
      */
const trackUploadNewTapped = (info: UploadNewTappedInfo) => track('upload_new_tapped', info);


/**
      

      */
const trackOutputConversionStarted = (info: OutputConversionStartedInfo) => track('output_conversion_started', info);


/**
      
      */
const trackOutputConversionCompleted = (info: OutputConversionCompletedInfo) => track('output_conversion_completed', info);


/**
      
      */
const trackOneTimePopupShown = () => track('one_time_popup_shown');


/**
      
      */
const trackUpgradeModalDismissed = () => track('upgrade_modal_dismissed');


/**
      
      */
const trackUpgradeModalConfirmed = (info: UpgradeModalConfirmedInfo) => track('upgrade_modal_confirmed', info);


/**
      
      */
const trackUpgradeModalUpgradeFailed = (info: UpgradeModalUpgradeFailedInfo) => track('upgrade_modal_upgrade_failed', info);


/**
      
      */
const trackUpgradeModalUpgradeSuccess = (info: UpgradeModalUpgradeSuccessInfo) => track('upgrade_modal_upgrade_success', info);


/**
      undefined
      */
const trackPaywallTierConfirmed = (info: PaywallTierConfirmedInfo) => track('paywall_tier_confirmed', info);


/**
      undefined
      */
const trackPaywallTierSelected = (info: PaywallTierSelectedInfo) => track('paywall_tier_selected', info);


/**
      
      */
const trackPaywallEmailReminderDisabled = (info: PaywallEmailReminderDisabledInfo) => track('paywall_email_reminder_disabled', info);


/**
      
      */
const trackPaywallEmailReminderEnabled = (info: PaywallEmailReminderEnabledInfo) => track('paywall_email_reminder_enabled', info);


/**
      

      */
const trackSubscribeTapped = (info: SubscribeTappedInfo) => track('subscribe_tapped', info);


/**
      
      */
const trackPcpFtTapped = () => track('pcp_ft_tapped');


/**
      
      */
const trackPcpWeeklyTapped = (info: PcpWeeklyTappedInfo) => track('pcp_weekly_tapped', info);


/**
      
      */
const trackPcpYearlyTapped = (info: PcpYearlyTappedInfo) => track('pcp_yearly_tapped', info);


/**
      
      */
const trackPcpContinueTapped = (info: PcpContinueTappedInfo) => track('pcp_continue_tapped', info);


/**
      
      */
const trackPcpOthersTapped = (info: PcpOthersTappedInfo) => track('pcp_others_tapped', info);


/**
      
      */
const trackPcpDismissed = (info: PcpDismissedInfo) => track('pcp_dismissed', info);


/**
      
      */
const trackOcpIntroTapped = () => track('ocp_intro_tapped');


/**
      
      */
const trackOcpFtPlanTapped = () => track('ocp_ft_plan_tapped');


/**
      
      */
const trackOcpContinueTapped = (info: OcpContinueTappedInfo) => track('ocp_continue_tapped', info);


/**
      
      */
const trackOcpOthersTapped = () => track('ocp_others_tapped');


/**
      
      */
const trackOcpDismissed = () => track('ocp_dismissed');


/**
      
      */
const trackPaywallPriceSelected = (info: PaywallPriceSelectedInfo) => track('paywall_price_selected', info);


/**
      
      */
const trackPaywallShown = (info: PaywallShownInfo) => track('paywall_shown', info);


/**
      
      */
const trackPaymentSelected = (info: PaymentSelectedInfo) => track('payment_selected', info);


/**
      
      */
const trackPaymentCompleted = (info: PaymentCompletedInfo) => track('payment_completed', info);


/**
      
      */
const trackPaywallDismissed = (info: PaywallDismissedInfo) => track('paywall_dismissed', info);


/**
      
      */
const trackFreeTrialEnabled = (info: FreeTrialEnabledInfo) => track('free_trial_enabled', info);


/**
      
      */
const trackFreeTrialDisabled = (info: FreeTrialDisabledInfo) => track('free_trial_disabled', info);


/**
      
      */
const trackFreeTrialTapped = (info: FreeTrialTappedInfo) => track('free_trial_tapped', info);


/**
      



      */
const trackStripeCardLimitReached = (info: StripeCardLimitReachedInfo) => track('stripe_card_limit_reached', info);


/**
      
      */
const trackAccountTapped = (info: AccountTappedInfo) => track('account_tapped', info);


/**
      
      */
const trackSettingsGeneralTapped = (info: SettingsGeneralTappedInfo) => track('settings_general_tapped', info);


/**
      
      */
const trackSettingsSubscriptionTapped = (info: SettingsSubscriptionTappedInfo) => track('settings_subscription_tapped', info);


/**
      
      */
const trackSettingsCancelPlanTapped = (info: SettingsCancelPlanTappedInfo) => track('settings_cancel_plan_tapped', info);


/**
      

      */
const trackSettingsWithdrawalTapped = (info: SettingsWithdrawalTappedInfo) => track('settings_withdrawal_tapped', info);


/**
      
      */
const trackSettingsUpgradePlanTapped = (info: SettingsUpgradePlanTappedInfo) => track('settings_upgrade_plan_tapped', info);


/**
      
      */
const trackSettingsLogoutTapped = (info: SettingsLogoutTappedInfo) => track('settings_logout_tapped', info);


/**
      

      */
const trackCancellationConfirmedModalShown = (info: CancellationConfirmedModalShownInfo) => track('cancellation_confirmed_modal_shown', info);


/**
      
      */
const trackCancellationFailedModalShown = (info: CancellationFailedModalShownInfo) => track('cancellation_failed_modal_shown', info);


/**
      
      */
const trackCancellationFailedModalTryAgainTapped = (info: CancellationFailedModalTryAgainTappedInfo) => track('cancellation_failed_modal_try_again_tapped', info);


/**
      
      */
const trackCancellationFailedModalContactSupportTapped = (info: CancellationFailedModalContactSupportTappedInfo) => track('cancellation_failed_modal_contact_support_tapped', info);


/**
      

      */
const trackCancellationModalShown = (info: CancellationModalShownInfo) => track('cancellation_modal_shown', info);


/**
      
      */
const trackCancellationModalAccepted = (info: CancellationModalAcceptedInfo) => track('cancellation_modal_accepted', info);


/**
      
      */
const trackCancellationModalDismissed = (info: CancellationModalDismissedInfo) => track('cancellation_modal_dismissed', info);


/**
      
      */
const trackWithdrawalModalShown = (info: WithdrawalModalShownInfo) => track('withdrawal_modal_shown', info);


/**
      
      */
const trackWithdrawalModalAccepted = (info: WithdrawalModalAcceptedInfo) => track('withdrawal_modal_accepted', info);


/**
      
      */
const trackWithdrawalModalDismissed = (info: WithdrawalModalDismissedInfo) => track('withdrawal_modal_dismissed', info);


/**
      
      */
const trackWithdrawalModalEmailSubmitted = (info: WithdrawalModalEmailSubmittedInfo) => track('withdrawal_modal_email_submitted', info);


/**
      
      */
const trackWithdrawalModalCompleted = (info: WithdrawalModalCompletedInfo) => track('withdrawal_modal_completed', info);


/**
      
      */
const trackWithdrawalModalFailed = (info: WithdrawalModalFailedInfo) => track('withdrawal_modal_failed', info);


/**
      
      */
const trackWithdrawalModalRetryTapped = (info: WithdrawalModalRetryTappedInfo) => track('withdrawal_modal_retry_tapped', info);


/**
      
      */
const trackWithdrawalModalContactSupportTapped = (info: WithdrawalModalContactSupportTappedInfo) => track('withdrawal_modal_contact_support_tapped', info);


/**
      
      */
const trackMobileSubscriptionRedeemCompleted = (info: MobileSubscriptionRedeemCompletedInfo) => track('mobile_subscription_redeem_completed', info);


/**
      
      */
const trackMobileSubscriptionRedeemFailed = (info: MobileSubscriptionRedeemFailedInfo) => track('mobile_subscription_redeem_failed', info);


/**
      
      */
const trackMobileSubscriptionRedeemStarted = (info: MobileSubscriptionRedeemStartedInfo) => track('mobile_subscription_redeem_started', info);


/**
      
      */
const trackSettingsPrivacySectionTapped = (info: SettingsPrivacySectionTappedInfo) => track('settings_privacy_section_tapped', info);


/**
      
      */
const trackShareButtonClick = (info: ShareButtonClickInfo) => track('share_button_click', info);


/**
      
      */
const trackShareTabShown = () => track('share_tab_shown');


/**
      undefined
      */
const trackShareModalCopy = (info: ShareModalCopyInfo) => track('share_modal_copy', info);


/**
      undefined
      */
const trackShareModalDismissed = (info: ShareModalDismissedInfo) => track('share_modal_dismissed', info);


/**
      undefined
      */
const trackShareModalShown = (info: ShareModalShownInfo) => track('share_modal_shown', info);


/**
      
      */
const trackSharedImageUnavailable = (info: SharedImageUnavailableInfo) => track('shared_image_unavailable', info);


/**
      
      */
const trackSharedImageShown = (info: SharedImageShownInfo) => track('shared_image_shown', info);


/**
      
      */
const trackPopupMarketingConsentShown = (info: PopupMarketingConsentShownInfo) => track('popup_marketing_consent_shown', info);


/**
      
      */
const trackPopupMarketingConsentClosed = () => track('popup_marketing_consent_closed');


/**
      
      */
const trackPopupMarketingConsentAccepted = (info: PopupMarketingConsentAcceptedInfo) => track('popup_marketing_consent_accepted', info);


/**
      
      */
const trackMarketingToggleChanged = (info: MarketingToggleChangedInfo) => track('marketing_toggle_changed', info);


/**
      
      */
const trackPopupImageTrainingConsentShown = (info: PopupImageTrainingConsentShownInfo) => track('popup_image_training_consent_shown', info);


/**
      
      */
const trackPopupImageTrainingConsentAccepted = (info: PopupImageTrainingConsentAcceptedInfo) => track('popup_image_training_consent_accepted', info);


/**
      
      */
const trackPopupImageTrainingConsentNotAccepted = (info: PopupImageTrainingConsentNotAcceptedInfo) => track('popup_image_training_consent_not_accepted', info);


/**
      
      */
const trackImageTrainingToggleChanged = (info: ImageTrainingToggleChangedInfo) => track('image_training_toggle_changed', info);


/**
      
      */
const trackSecretMenuOpened = (info: SecretMenuOpenedInfo) => track('secret_menu_opened', info);


/**
      
      */
const trackSecretMenuAttemptFailed = (info: SecretMenuAttemptFailedInfo) => track('secret_menu_attempt_failed', info);


/**
      
      */
const trackSecretMenuExperimentsUpdated = (info: SecretMenuExperimentsUpdatedInfo) => track('secret_menu_experiments_updated', info);


/**
      
      */
const trackGiftCodeSubmitted = (info: GiftCodeSubmittedInfo) => track('gift_code_submitted', info);


/**
      
      */
const trackGiftCodeAccepted = (info: GiftCodeAcceptedInfo) => track('gift_code_accepted', info);


/**
      
      */
const trackGiftCodeErrored = (info: GiftCodeErroredInfo) => track('gift_code_errored', info);


/**
      
      */
const trackFeatureRankingSurveyDisplayed = () => track('feature_ranking_survey_displayed');


/**
      
      */
const trackFeatureRankingSurveyDismissed = () => track('feature_ranking_survey_dismissed');


/**
      

      */
const trackFeatureRankingSurveyCompleted = () => track('feature_ranking_survey_completed');


/**
      
      */
const trackPhotoshopPluginTapped = () => track('photoshop_plugin_tapped');


/**
      

      */
const trackPhotoshopPluginEmailSent = () => track('photoshop_plugin_email_sent');


/**
      
      */
const trackAutoColorDiscoveryShown = () => track('auto_color_discovery_shown');


/**
      
      */
const trackAutoColorDiscoveryExploreTapped = () => track('auto_color_discovery_explore_tapped');


/**
      
      */
const trackAutoColorDiscoveryBackTapped = () => track('auto_color_discovery_back_tapped');


/**
      

      */
const trackAutoColorDiscoveryDismissed = () => track('auto_color_discovery_dismissed');


/**
      
      */
const trackDownloadAppCtaPageview = (info: DownloadAppCtaPageviewInfo) => track('download_app_cta_pageview', info);


/**
      
      */
const trackDownloadAppCtaDownloadAppTapped = (info: DownloadAppCtaDownloadAppTappedInfo) => track('download_app_cta_download_app_tapped', info);

  return {
    trackAppredirect01Buttonclicked,
    trackAppredirect01Pageview,
    trackSessionStart,
    trackSettingsLoaded,
    trackGtmLoaded,
    trackVValueGenerated,
    trackCookiesAccepted,
    trackCookiesRejected,
    trackCookiesCustomizing,
    trackCookiesCustomized,
    trackHomepageSliderInteraction,
    trackBulkUploadLimitError,
    trackBulkUploadFormatError,
    trackVideoPromotionShown,
    trackCookieLoginCtaShown,
    trackCookieLoginCtaEligibilityEvaluated,
    trackCookieLoginCtaLoginTapped,
    trackCookieLoginCtaDismissed,
    trackVideoPromotionTapped,
    trackVideoPromotionDismissed,
    trackLanguagePickerTapped,
    trackLanguageSelected,
    trackLoginTapped,
    trackLoginShown,
    trackLoginDismissed,
    trackLoginStarted,
    trackLoginCompleted,
    trackUploadStarted,
    trackTryPhotoFreeEnhanceTapped,
    trackAiSettingsSavingIconTapped,
    trackAiSettingsSaveButtonTapped,
    trackAiSettingsSaved,
    trackAiSettingsSavingModalShown,
    trackAiSettingsSavingModalAccepted,
    trackAiSettingsSavingModalDismissed,
    trackDownloadCtaPopupDisplayed,
    trackDownloadCtaPopupUpgradePlanTapped,
    trackDownloadCtaPopupDismissed,
    trackVideoEnhanceSubscribePopupDisplayed,
    trackVideoUploadCtaPopupSingleTaskTapped,
    trackVideoUploadCtaPopupUpgradePlanTapped,
    trackVideoUploadCtaPopupTrySubscribeTapped,
    trackVideoUploadCtaPopupLoginTapped,
    trackVideoUploadCtaPopupDismissed,
    trackAiModelsDropdownClickCtaPopupShown,
    trackAiModelsDropdownClickCtaPopupTrySubscribeTapped,
    trackAiModelsDropdownClickCtaPopupLoginTapped,
    trackAiModelsDropdownClickCtaPopupDismissed,
    trackAiModelsVariantsClickCtaPopupShown,
    trackAiModelsVariantsClickCtaPopupTrySubscribeTapped,
    trackAiModelsVariantsClickCtaPopupLoginTapped,
    trackAiModelsVariantsClickCtaPopupUpgradePlanTapped,
    trackAiModelsVariantsClickCtaPopupDismissed,
    trackBatchProcessingCtaPopupShown,
    trackBatchProcessingCtaPopupDismissed,
    trackBatchProcessingCtaPopupUpgradePlanTapped,
    trackBatchProcessingCtaPopupSingleTaskTapped,
    trackBatchProcessingCtaPopupTrySubscribeTapped,
    trackBatchProcessingCtaPopupLoginTapped,
    trackVideoEnhanceLimitError,
    trackUploadCompleted,
    trackUploadTooManyFiles,
    trackOnboardingSurveyDisplayed,
    trackOnboardingSurveyDismissed,
    trackOnboardingSurveyCompleted,
    trackSurveySubmitted,
    trackReprocessingStarted,
    trackReprocessingCompleted,
    trackProcessingStarted,
    trackProcessingCompleted,
    trackProcessingCancelled,
    trackServerDownloadStarted,
    trackServerDownloadCompleted,
    trackProcessedImageShown,
    trackProcessedImageUnavailable,
    trackTutorialSkipped,
    trackTutorialCompleted,
    trackOutputFormatConversionCtaPopupUpgradePlanTapped,
    trackOutputFormatConversionCtaPopupTrySubscribeTapped,
    trackOutputFormatConversionCtaPopupLoginTapped,
    trackOutputFormatConversionCtaPopupDismissed,
    trackOutputFormatConversionSubscribePopupDisplayed,
    trackEditorSliderInteraction,
    trackEditorZoomed,
    trackEditorFitted,
    trackEditorPanned,
    trackEditorImageModelSelected,
    trackDownloadTapped,
    trackBatchDownloadTapped,
    trackDownloadSidebarOpened,
    trackUserDownloadTriggered,
    trackAiModelMismatchModalShown,
    trackAiModelMismatchModalAccepted,
    trackAiModelMismatchModalNotAccepted,
    trackOverwriteAllFormatsModalShown,
    trackOverwriteAllFormatsModalAccepted,
    trackOverwriteAllFormatsModalNotAccepted,
    trackUploadNewTapped,
    trackOutputConversionStarted,
    trackOutputConversionCompleted,
    trackOneTimePopupShown,
    trackUpgradeModalDismissed,
    trackUpgradeModalConfirmed,
    trackUpgradeModalUpgradeFailed,
    trackUpgradeModalUpgradeSuccess,
    trackPaywallTierConfirmed,
    trackPaywallTierSelected,
    trackPaywallEmailReminderDisabled,
    trackPaywallEmailReminderEnabled,
    trackSubscribeTapped,
    trackPcpFtTapped,
    trackPcpWeeklyTapped,
    trackPcpYearlyTapped,
    trackPcpContinueTapped,
    trackPcpOthersTapped,
    trackPcpDismissed,
    trackOcpIntroTapped,
    trackOcpFtPlanTapped,
    trackOcpContinueTapped,
    trackOcpOthersTapped,
    trackOcpDismissed,
    trackPaywallPriceSelected,
    trackPaywallShown,
    trackPaymentSelected,
    trackPaymentCompleted,
    trackPaywallDismissed,
    trackFreeTrialEnabled,
    trackFreeTrialDisabled,
    trackFreeTrialTapped,
    trackStripeCardLimitReached,
    trackAccountTapped,
    trackSettingsGeneralTapped,
    trackSettingsSubscriptionTapped,
    trackSettingsCancelPlanTapped,
    trackSettingsWithdrawalTapped,
    trackSettingsUpgradePlanTapped,
    trackSettingsLogoutTapped,
    trackCancellationConfirmedModalShown,
    trackCancellationFailedModalShown,
    trackCancellationFailedModalTryAgainTapped,
    trackCancellationFailedModalContactSupportTapped,
    trackCancellationModalShown,
    trackCancellationModalAccepted,
    trackCancellationModalDismissed,
    trackWithdrawalModalShown,
    trackWithdrawalModalAccepted,
    trackWithdrawalModalDismissed,
    trackWithdrawalModalEmailSubmitted,
    trackWithdrawalModalCompleted,
    trackWithdrawalModalFailed,
    trackWithdrawalModalRetryTapped,
    trackWithdrawalModalContactSupportTapped,
    trackMobileSubscriptionRedeemCompleted,
    trackMobileSubscriptionRedeemFailed,
    trackMobileSubscriptionRedeemStarted,
    trackSettingsPrivacySectionTapped,
    trackShareButtonClick,
    trackShareTabShown,
    trackShareModalCopy,
    trackShareModalDismissed,
    trackShareModalShown,
    trackSharedImageUnavailable,
    trackSharedImageShown,
    trackPopupMarketingConsentShown,
    trackPopupMarketingConsentClosed,
    trackPopupMarketingConsentAccepted,
    trackMarketingToggleChanged,
    trackPopupImageTrainingConsentShown,
    trackPopupImageTrainingConsentAccepted,
    trackPopupImageTrainingConsentNotAccepted,
    trackImageTrainingToggleChanged,
    trackSecretMenuOpened,
    trackSecretMenuAttemptFailed,
    trackSecretMenuExperimentsUpdated,
    trackGiftCodeSubmitted,
    trackGiftCodeAccepted,
    trackGiftCodeErrored,
    trackFeatureRankingSurveyDisplayed,
    trackFeatureRankingSurveyDismissed,
    trackFeatureRankingSurveyCompleted,
    trackPhotoshopPluginTapped,
    trackPhotoshopPluginEmailSent,
    trackAutoColorDiscoveryShown,
    trackAutoColorDiscoveryExploreTapped,
    trackAutoColorDiscoveryBackTapped,
    trackAutoColorDiscoveryDismissed,
    trackDownloadAppCtaPageview,
    trackDownloadAppCtaDownloadAppTapped
  };
      }
const anonymousActionInfoMap = {"app-redirect-01_button-clicked":{"page":true,"url":false},"app-redirect-01_pageview":{"url":false},"session_start":{},"settings_loaded":{"page":true,"url":false},"gtm_loaded":{"fbc":false,"fbp":false,"page":true,"url":false},"v_value_generated":{"fbc":false,"fbp":false,"url":false,"value":false},"cookies_accepted":{"page":true,"url":false},"cookies_rejected":{"page":true,"url":false},"cookies_customizing":{"page":true,"url":false},"cookies_customized":{"page":true,"url":false},"homepage_slider_interaction":{"page":true,"url":false},"bulk_upload_limit_error":{"errorType":true,"fileNumber":true,"page":true,"url":false},"bulk_upload_format_error":{"errorType":true,"fileFormat":true,"page":true,"url":false},"video_promotion_shown":{"page":true,"url":false},"cookie_login_cta_shown":{"page":true,"url":false},"cookie_login_cta_eligibility_evaluated":{"eligible":true,"suppressionReason":true,"page":true,"url":false},"cookie_login_cta_login_tapped":{"page":true,"url":false},"cookie_login_cta_dismissed":{"page":true,"url":false},"video_promotion_tapped":{"page":true,"url":false,"source":true},"video_promotion_dismissed":{"page":true,"url":false},"language_picker_tapped":{"page":true,"url":false,"email":false,"fbp":false,"fpc":false},"language_selected":{"language":true,"page":true,"url":false,"fbp":false},"login_tapped":{"fbc":false,"fbp":false,"actionValue":false,"page":true,"url":false},"login_shown":{"fbc":false,"fbp":false,"page":true,"previousAction":true,"url":false},"login_dismissed":{"page":true,"previousAction":false,"url":false},"login_started":{"actionValue":false,"fbc":false,"fbp":false,"page":true,"url":false,"from":true},"login_completed":{"actionValue":true,"email":false,"fbc":false,"fbp":false,"page":true,"previousAction":true,"url":false},"upload_started":{"actionValue":true,"email":false,"fbc":false,"fbp":false,"page":true,"url":false,"mediaType":true,"mediaQuantity":true},"try_photo_free_enhance_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"ai_settings_saving_icon_tapped":{"is_logged_in":false,"will_open":true},"ai_settings_save_button_tapped":{"ai_model":true,"ai_model_parameters":true},"ai_settings_saved":{"ai_model":true,"ai_model_parameters":true},"ai_settings_saving_modal_shown":{},"ai_settings_saving_modal_accepted":{},"ai_settings_saving_modal_dismissed":{},"download_cta_popup_displayed":{"fbc":false,"fbp":false,"page":true,"url":false},"download_cta_popup_upgrade_plan_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"download_cta_popup_dismissed":{"fbc":false,"fbp":false,"page":true,"url":false},"video_enhance_subscribe_popup_displayed":{"fbc":false,"fbp":false,"page":true,"url":false},"video_upload_cta_popup_single_task_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"video_upload_cta_popup_upgrade_plan_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"video_upload_cta_popup_try_subscribe_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"video_upload_cta_popup_login_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"video_upload_cta_popup_dismissed":{"fbc":false,"fbp":false,"page":true,"url":false},"ai_models_dropdown_click_cta_popup_shown":{},"ai_models_dropdown_click_cta_popup_try_subscribe_tapped":{},"ai_models_dropdown_click_cta_popup_login_tapped":{},"ai_models_dropdown_click_cta_popup_dismissed":{},"ai_models_variants_click_cta_popup_shown":{"chosen_style":true},"ai_models_variants_click_cta_popup_try_subscribe_tapped":{},"ai_models_variants_click_cta_popup_login_tapped":{},"ai_models_variants_click_cta_popup_upgrade_plan_tapped":{},"ai_models_variants_click_cta_popup_dismissed":{},"batch_processing_cta_popup_shown":{"fbc":false,"fbp":false,"page":true,"url":false},"batch_processing_cta_popup_dismissed":{"fbc":false,"fbp":false,"page":true,"url":false},"batch_processing_cta_popup_upgrade_plan_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"batch_processing_cta_popup_single_task_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"batch_processing_cta_popup_try_subscribe_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"batch_processing_cta_popup_login_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"video_enhance_limit_error":{"fbc":false,"fbp":false,"page":true,"url":false,"errorType":true},"upload_completed":{"actionValue":true,"email":false,"fbc":false,"fbp":false,"page":true,"url":false,"mediaType":true},"upload_too_many_files":{"actionValue":true,"email":false,"fbc":false,"fbp":false,"page":true,"url":false},"onboarding_survey_displayed":{"fbc":false,"fbp":false,"page":true,"url":false},"onboarding_survey_dismissed":{"fbc":false,"fbp":false,"page":true,"url":false},"onboarding_survey_completed":{"fbc":false,"fbp":false,"page":true,"url":false,"onboarding_survey_responses":true},"survey_submitted":{"fbc":false,"fbp":false,"page":true,"url":false,"webUserId":false},"reprocessing_started":{"actionValue":true,"fbc":false,"fbp":false,"page":true,"url":false,"mediaType":false},"reprocessing_completed":{"actionValue":true,"fbc":false,"fbp":false,"page":true,"url":false,"mediaType":true,"mediaQuantity":true,"aiModels":true,"aiModelParameters":true,"aiModelParametersList":true},"processing_started":{"actionValue":true,"fbc":false,"fbp":false,"page":false,"url":false,"mediaType":false},"processing_completed":{"actionValue":true,"email":false,"fbc":false,"fbp":false,"page":true,"url":false,"mediaType":true,"bulkUploadId":true,"mediaQuantity":true,"aiModels":true,"aiModelParameters":true,"aiModelParametersList":true},"processing_cancelled":{"actionValue":true,"email":false,"fbc":false,"fbp":false,"page":true,"url":false,"mediaType":true},"server_download_started":{"fbc":false,"fbp":false,"page":true,"url":false},"server_download_completed":{"email":false,"fbc":false,"fbp":false,"page":true,"url":false,"mediaType":true},"processed_image_shown":{"email":false,"hasWatermark":true,"fbc":false,"fbp":false,"page":true,"url":false,"aiModel":true,"aiModelParameters":true},"processed_image_unavailable":{"page":true,"url":false,"fbp":false},"tutorial_skipped":{"page":true,"url":false,"tutorialId":true},"tutorial_completed":{"page":true,"url":false,"tutorialId":true},"output_format_conversion_cta_popup_upgrade_plan_tapped":{},"output_format_conversion_cta_popup_try_subscribe_tapped":{},"output_format_conversion_cta_popup_login_tapped":{},"output_format_conversion_cta_popup_dismissed":{},"output_format_conversion_subscribe_popup_displayed":{"requestedFormat":true},"editor_slider_interaction":{"fbc":false,"fbp":false,"page":true,"url":false},"editor_zoomed":{"fbc":false,"fbp":false,"page":true,"url":false},"editor_fitted":{"fbc":false,"fbp":false,"page":true,"url":false},"editor_panned":{"fbc":false,"fbp":false,"page":true,"url":false},"editor_image_model_selected":{"page":true,"url":false,"aiModel":true,"aiToolbarSelection":true},"download_tapped":{"email":false,"fbc":false,"fbp":false,"nextAction":true,"page":true,"url":false,"mediaType":true,"taskId":false,"extension":true,"aiModel":true,"aiModelParameters":true},"batch_download_tapped":{"bulkUploadId":false,"mediaQuantity":false},"download_sidebar_opened":{"media_type":true,"task_id":false},"user_download_triggered":{"email":false,"fbc":false,"fbp":false,"mimeType":true,"page":true,"url":false,"aiModel":true,"aiModelParameters":true,"mediaType":true},"ai_model_mismatch_modal_shown":{},"ai_model_mismatch_modal_accepted":{},"ai_model_mismatch_modal_not_accepted":{},"overwrite_all_formats_modal_shown":{},"overwrite_all_formats_modal_accepted":{},"overwrite_all_formats_modal_not_accepted":{},"upload_new_tapped":{"email":false,"fbc":false,"fbp":false,"page":true,"url":false},"output_conversion_started":{"fbc":false,"fbp":false,"mimeType":true,"page":true,"url":false},"output_conversion_completed":{"fbc":false,"fbp":false,"mimeType":true,"page":true,"url":false},"one_time_popup_shown":{},"upgrade_modal_dismissed":{},"upgrade_modal_confirmed":{"subscriptionProvider":false,"refundAmount":false,"daysLeft":false,"wasTrialing":false},"upgrade_modal_upgrade_failed":{"subscriptionProvider":false,"wasTrialing":false},"upgrade_modal_upgrade_success":{"subscriptionProvider":false,"refundAmount":false,"wasTrialing":false},"paywall_tier_confirmed":{"page":true,"url":false,"fbp":false,"email":false,"selectedTier":true,"isUpgrade":true},"paywall_tier_selected":{"page":true,"fbp":false,"url":false,"email":false,"paywallDesign":true,"selectedTier":true},"paywall_email_reminder_disabled":{"page":true,"url":false,"fbp":false},"paywall_email_reminder_enabled":{"page":true,"url":false,"fbp":false,"email":false},"subscribe_tapped":{"actionValue":false,"email":false,"fbc":false,"fbp":false,"page":true,"url":false},"pcp_ft_tapped":{},"pcp_weekly_tapped":{"freeTrial":true},"pcp_yearly_tapped":{"freeTrial":true},"pcp_continue_tapped":{"periodicity":true,"freeTrial":true},"pcp_others_tapped":{"freeTrial":true},"pcp_dismissed":{"freeTrial":true},"ocp_intro_tapped":{},"ocp_ft_plan_tapped":{},"ocp_continue_tapped":{"planChosen":true},"ocp_others_tapped":{},"ocp_dismissed":{},"paywall_price_selected":{"page":true,"fbp":false,"url":false,"priceIds":true,"priceId":true,"selectedPeriod":true,"isUpgrade":true},"paywall_shown":{"fbc":false,"fbp":false,"page":true,"previousAction":true,"priceIds":true,"type":true,"url":false},"payment_selected":{"fbc":false,"fbp":false,"page":true,"paymentPlatform":true,"paymentStrategy":true,"previousAction":true,"offerPlan":true,"freeTrialEnabled":true,"priceId":true,"url":false},"payment_completed":{"fbc":false,"fbp":false,"page":true,"paymentPlatform":true,"paymentStrategy":true,"priceId":true,"freeTrialEnabled":true,"emailReminderEnabled":true,"previousAction":true,"offerPlan":true,"url":false},"paywall_dismissed":{"fbc":false,"fbp":false,"page":true,"previousAction":true,"priceIds":true,"url":false,"email":false},"free_trial_enabled":{"previousAction":true,"fbc":false,"fbp":false,"page":true,"url":false,"priceIds":true},"free_trial_disabled":{"previousAction":true,"fbc":false,"fbp":false,"page":true,"url":false,"priceIds":true},"free_trial_tapped":{"fbc":false,"actionValue":true,"fbp":false,"page":true,"url":false,"email":false},"stripe_card_limit_reached":{"email":false},"account_tapped":{"actionValue":true,"page":true,"url":false},"settings_general_tapped":{"actionValue":true,"fbc":false,"fbp":false,"page":true,"url":false},"settings_subscription_tapped":{"actionValue":true,"fbc":false,"fbp":false,"page":true,"url":false},"settings_cancel_plan_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"settings_withdrawal_tapped":{"will_refund":true,"days_remaining":true,"provider":true,"fbc":false,"fbp":false,"page":true,"url":false},"settings_upgrade_plan_tapped":{"fbc":false,"fbp":false,"page":true,"url":false},"settings_logout_tapped":{"actionValue":true,"email":false,"fbc":false,"fbp":false,"page":true,"url":false},"cancellation_confirmed_modal_shown":{"is_email_cancellation":true,"cancellation_code":false},"cancellation_failed_modal_shown":{"is_email_cancellation":true,"cancellation_code":false},"cancellation_failed_modal_try_again_tapped":{"is_email_cancellation":true,"cancellation_code":false},"cancellation_failed_modal_contact_support_tapped":{"is_email_cancellation":true,"cancellation_code":false},"cancellation_modal_shown":{"is_email_cancellation":true,"cancellation_code":false},"cancellation_modal_accepted":{"is_email_cancellation":true,"cancellation_code":false},"cancellation_modal_dismissed":{"is_email_cancellation":true,"cancellation_code":false},"withdrawal_modal_shown":{"will_refund":true,"days_remaining":true,"provider":true},"withdrawal_modal_accepted":{"will_refund":true,"days_remaining":true,"provider":true},"withdrawal_modal_dismissed":{"will_refund":true,"days_remaining":true,"provider":true},"withdrawal_modal_email_submitted":{"will_refund":true,"days_remaining":true,"provider":true},"withdrawal_modal_completed":{"will_refund":true,"days_remaining":true,"provider":true,"refunded_amount_cents":true},"withdrawal_modal_failed":{"will_refund":true,"days_remaining":true,"provider":true,"error_code":true},"withdrawal_modal_retry_tapped":{"will_refund":true,"days_remaining":true,"provider":true,"error_code":true},"withdrawal_modal_contact_support_tapped":{"will_refund":true,"days_remaining":true,"provider":true,"error_code":true},"mobile_subscription_redeem_completed":{"url":false,"backendId":false},"mobile_subscription_redeem_failed":{"url":false,"backendId":false},"mobile_subscription_redeem_started":{"url":false,"backendId":false},"settings_privacy_section_tapped":{"page":true,"email":false,"fbp":false,"url":false},"share_button_click":{"page":true,"url":false,"email":false},"share_tab_shown":{},"share_modal_copy":{"page":true,"url":false,"fbp":false,"email":false,"from":true},"share_modal_dismissed":{"page":true,"url":false,"fbp":false,"email":false},"share_modal_shown":{"page":true,"url":false,"fbp":false,"email":false},"shared_image_unavailable":{"fbc":false,"fbp":false,"page":true,"url":false},"shared_image_shown":{"fbc":false,"fbp":false,"page":true,"url":false,"hasWatermark":true},"popup_marketing_consent_shown":{"page":true,"fbp":false,"url":false,"email":false},"popup_marketing_consent_closed":{},"popup_marketing_consent_accepted":{"page":true,"url":false,"fbp":false},"marketing_toggle_changed":{"choice":true,"page":true,"url":false,"fbc":false,"fbp":false},"popup_image_training_consent_shown":{"page":true,"url":false,"fbp":false},"popup_image_training_consent_accepted":{"page":true,"url":false,"fbp":false,"email":false},"popup_image_training_consent_not_accepted":{"page":true,"url":false,"fbp":false},"image_training_toggle_changed":{"choice":true,"page":true,"url":true,"fbp":false,"fbc":false},"secret_menu_opened":{"page":true,"url":false,"fbp":false},"secret_menu_attempt_failed":{"page":true,"url":false,"fbp":false},"secret_menu_experiments_updated":{"page":true,"url":false,"fbp":false},"gift_code_submitted":{"page":true,"url":false},"gift_code_accepted":{"redeemCode":false,"page":true,"url":false,"fbp":false},"gift_code_errored":{"page":true,"fbp":false,"redeemCode":false,"url":false,"errorMessage":true},"feature_ranking_survey_displayed":{},"feature_ranking_survey_dismissed":{},"feature_ranking_survey_completed":{},"photoshop_plugin_tapped":{},"photoshop_plugin_email_sent":{},"auto_color_discovery_shown":{},"auto_color_discovery_explore_tapped":{},"auto_color_discovery_back_tapped":{},"auto_color_discovery_dismissed":{},"download_app_cta_pageview":{"page":true,"url":false},"download_app_cta_download_app_tapped":{"page":true,"url":false}}
export const isAnonymousActionInfo = (actionKind: string, actionInfo: string): boolean => anonymousActionInfoMap[actionKind]?.[actionInfo] ?? false